
import { defineComponent } from "vue";
import Chip from "primevue/chip";
import firebase from "../firebase/firebase";
import { useStore } from "vuex";
import Button from "primevue/button";

export default defineComponent({
  name: "SongCard",
  components: { Chip, Button },
  props: {
    songId: {
      type: String,
      default: "",
    },
    displayButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const tag: Array<string> = [];
    return {
      screenTitle: "",
      tag: tag,
      videoId: "",
    };
  },
  setup() {
    const store = useStore();
    return {
      store,
    };
  },
  computed: {
    bgColor(): string {
      if (
        this.store.state.list.ids[this.store.state.list.cursor] == this.songId
      ) {
        return "whitesmoke";
      }
      return "white";
    },
    added(): boolean {
      return this.store.state.list.ids.includes(this.songId);
    },
    nowPlaying(): boolean {
      return (
        this.store.state.list.ids[this.store.state.list.cursor] == this.songId
      );
    },
  },
  mounted: async function () {
    await firebase
      .firestore()
      .collection("songs")
      .doc(this.songId)
      .get()
      .then((d) => {
        const tmp: any = d.data();
        this.screenTitle = tmp.screenTitle;
        this.videoId = tmp.videoId;
        tmp.tag.forEach((element: string) => {
          this.tag.push(element);
        });
      });
    console.log("songcard mounted");
  },
  methods: {
    addList() {
      this.store.commit("addList", this.songId);
    },
    removeList() {
      this.store.commit("removeList", this.songId);
    },
  },
});
